import AddEntryModal from './AddEntryModal'

export default AddEntryModal
